/**
 * 依赖 index.html 中的 aliyun-oss-sdk（全局 OSS）。
 * 密钥建议逐步迁到环境变量，勿提交真实密钥到仓库。
 * @see https://help.aliyun.com/zh/oss/developer-reference/browser-js
 */
const OSS = globalThis.OSS

if (typeof OSS !== 'function') {
    console.error('[request_vue3/oss] 未找到全局 OSS，请确认已引入 aliyun-oss-sdk')
}

export const client = new OSS({
    region: import.meta.env.VITE_OSS_REGION || 'oss-cn-shenzhen',
    accessKeyId: import.meta.env.VITE_OSS_ACCESS_KEY_ID || 'LTAI5tJNbALM6XakcA5bcNw4',
    accessKeySecret: import.meta.env.VITE_OSS_ACCESS_KEY_SECRET || 'ynAjdvTMfX50ljLhN3ohs5lSPfyOHb',
    bucket: import.meta.env.VITE_OSS_BUCKET || 'dfsk-3d'
})
